// Route components
import Page from '@/components/PageMaster.vue'
// import Posts from '@/components/PostsComponent.vue'
// import NotFound from '@/components/404Page.vue'
// import AuthorArchive from '@/components/AuthorArchive.vue'
// import DateArchive from '@/components/DateArchive.vue'
// import CategoryArchive from '@/components/CategoryArchive.vue'
// import TagArchive from '@/components/TagArchive.vue'
// import Single from '@/components/SingleComponent.vue'
import SingleTeam from '@/components/SingleTeam.vue'
import SingleLeadership from '@/components/SingleLeadership.vue'
// Route paths as formatted in WP permalink settings
import paths from './paths'
// Route composition utilities
import { categorySlugFromParams, pageFromPath } from './utils'

const { show_on_front, page_for_posts, page_on_front } =
  window.__VUE_WORDPRESS__.routing

const postsPageRoute =
  show_on_front === 'page' && page_for_posts
    ? {
        path: paths.postsPage(page_for_posts),
        component: () => import('@/components/Posts/PostsComponent.vue'),
        name: 'Posts',
        props: (route) => ({
          page: pageFromPath(route.path),
          slug: page_for_posts,
        }),
      }
    : null

const rootRoute =
  show_on_front === 'page' && page_on_front
    ? {
        path: '/',
        component: Page,
        name: 'Home',
        meta: { bodyClass: 'v-home' },
        props: () => ({
          slug: page_on_front,
          isHomepage: true,
          showIntro: true,
        }),
      }
    : null

const routes = [
  rootRoute,
  postsPageRoute,
  {
    path: '/404',
    component: () => import('@/components/404Page.vue'),
    name: '404',
  },
  {
    path: paths.authorArchive,
    component: () => import('@/components/AuthorArchive.vue'),
    name: 'AuthorArchive',
    props: (route) =>
      Object.assign(route.params, { page: pageFromPath(route.path) }),
  },
  {
    path: paths.dateArchive,
    component: () => import('@/components/DateArchive.vue'),
    name: 'DateArchive',
    props: (route) =>
      Object.assign(route.params, { page: pageFromPath(route.path) }),
  },
  {
    path: paths.categoryArchive,
    component: () => import('@/components/CategoryArchive.vue'),
    name: 'CategoryArchive',
    props: (route) =>
      Object.assign(route.params, {
        slug: categorySlugFromParams(route.params),
        page: pageFromPath(route.path),
      }),
  },
  {
    path: paths.tagArchive,
    component: () => import('@/components/TagArchive.vue'),
    name: 'TagArchive',
    props: (route) =>
      Object.assign(route.params, { page: pageFromPath(route.path) }),
  },
  {
    path: '/team/:slug',
    component: SingleTeam,
    name: 'SingleTeam',
    props: (route) => ({ slug: route.params.slug }),
  },
  {
    path: '/leadership/:slug',
    component: SingleLeadership,
    name: 'SingleLeadership',
    props: (route) => ({ slug: route.params.slug }),
  },
  {
    path: paths.single,
    component: () => import('@/components/SingleComponent.vue'),
    name: 'Single',
    props: (route) => ({ slug: route.params.slug, newsSlug: page_for_posts }),
  },
  {
    path: '/:slugs+',
    component: Page,
    name: 'Page',
    props: (route) => ({
      slug: route.params.slugs[0]
        .split('/')
        .filter((s) => s)
        .pop(),
    }),
  },
].filter((route) => route) // Removes empty route objects

export default routes
